
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/state-news",
      function () {
        return require("private-next-pages/state-news/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/state-news"])
      });
    }
  